module.exports = __webpack_public_path__ + "img/r1.4c99ef60.jpg";